import { ActionType } from '../../../stores/action-types';
import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React, { useCallback, ChangeEvent } from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { addSystemsToGroup } from '../../../stores/actions/installerActions';
import { getSystemGroups } from '../../../stores/actions/dashboardActions';
import { getSystemsForGroup } from '../../../stores/actions/actions';
import { connect } from 'react-redux';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import SystemIcon from '../../../components/ShortStatus/SystemIcon';
import utils from '../../../helpers/GlobalVariables';
import { ISystem } from '../../../helpers/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { PickList } from 'primereact/picklist';

import '../InstallerPanel.css';
import { forEach } from 'lodash';

interface IAddSystemsToGroupProps {
    systemGroups: any[];
    systemsForGroup: any[];
    classes: ClassNameMap;
    addSystemsToGroupFailed: boolean;
    addSystemsToGroupSucceeded: boolean;
    disableRefreshButton: boolean;
    emptySystem: boolean;
    getSystemGroups: () => void;
    getSystemsForGroup: (groupID) => void;
    mobileView: boolean;
    addSystemsToGroup: (accID, systemIDs) => void;
    systems: ISystem[];
}

const AddSystemsToGroup = ({
    systemGroups,
    systemsForGroup,
    addSystemsToGroupFailed,
    addSystemsToGroupSucceeded,
    disableRefreshButton,
    emptySystem,
    getSystemGroups,
    getSystemsForGroup,
    mobileView,
    addSystemsToGroup,
    systems,
    ...props
}: IAddSystemsToGroupProps) => {
    const { classes } = props;
    const [error, setError] = useState<boolean>(false)
	const [pickedSystems, setPickedSystems] = useState([]);
    const [pickedGroup, setPickedGroup] = useState<string>("");
    const [allSystems, setAllSystems] = useState([]);
    const dispatch = useDispatch();
    const closeNotificationTimer = useRef(null);
    const [emptySystemError, setEmptySystemError] = useState<boolean>(false);
    const systemIds = systems.map(el => el.ID);
    const systemNamesByIds = Object.fromEntries(systems.map(x => [x.ID, x.name])); 
    const systemGroupOptions = systemGroups ? systemGroups
        .sort((a, b) => (a.name > b.name) ? 1 : -1)
        .map((group) => group.name).sort() : [];

    const closeAddSystemsToGroupNotification = useCallback(() => {
        dispatch({ type: ActionType.CLOSE_ADD_SYSTEMS_TO_GROUP_NOTIFICATION });
    }, [dispatch]);

    useEffect(() => {
        closeAddSystemsToGroupNotification();
        setEmptySystemError(false);
    }, [closeAddSystemsToGroupNotification, setEmptySystemError]);

    useEffect(() => {
        getSystemGroups();
    }, [getSystemGroups]);

    useEffect(() => {
        if (addSystemsToGroupFailed || addSystemsToGroupSucceeded) {
            closeNotificationTimer.current = setTimeout(closeAddSystemsToGroupNotification, 6000);
        }
        if (emptySystemError) {
            closeNotificationTimer.current = setTimeout(() => {
                setEmptySystemError(false);
            }, 6000);
        }
        return () => {
            clearTimeout(closeNotificationTimer.current);
        };
    }, [closeAddSystemsToGroupNotification, addSystemsToGroupFailed, addSystemsToGroupSucceeded, emptySystemError]);

    useEffect(() => {
        if (systemsForGroup && systems) {
            const allSystems = [...systems].filter(a => !systemsForGroup.map(b=>b.ID).includes(a.ID))
            setAllSystems(allSystems);
        }
    }, [systems, systemsForGroup]);

    useEffect(() => {
        if (pickedGroup) {
            setPickedSystems(systemsForGroup);
        }
    }, [systemsForGroup]);


    useEffect(() => {
        if (systemGroups) {
            const systemIdsByNames = Object.fromEntries(systemGroups.map(x => [x.name, x.ID]));
            const id = systemIdsByNames[pickedGroup];
            if (id) {
                getSystemsForGroup(systemIdsByNames[pickedGroup]);
            }
        }

    }, [pickedGroup]);

    const handlePickGroup = (e: ChangeEvent<{ value: unknown }>, selected: string): void => {
        if (selected !== null && selected !== "") {
            setPickedGroup(selected);
        } else {
            setPickedGroup("")
        }
    };

    const handleAddSystemsToGroup = (): void => {
        if (pickedGroup !== "" && pickedSystems?.length) {
            const pickedSystemsIds = pickedSystems.map(system => system.ID);
            const groupID = systemGroups.filter((group) => group.name === pickedGroup)[0].ID;
            addSystemsToGroup(groupID, pickedSystemsIds)
        }
    }

    const onChange = (event) => {
        setAllSystems(event.source.sort((a, b) => (a.name > b.name) ? 1 : -1));
        setPickedSystems(event.target.sort((a, b) => (a.name > b.name) ? 1 : -1));
    };

    const itemTemplate = (system) => {
        let wasInGroup = false;
        systemsForGroup.forEach((s) => {
            if (s.ID === system.ID) {
                wasInGroup = true;
            }
        });

        return (
            <div style={{backgroundColor: !wasInGroup && pickedGroup ? 'floralwhite' : 'transparent'}} className="flex flex-wrap p-2 align-items-center gap-3">
                {system.name}
            </div>
        );
    };

    const pinButton = (): JSX.Element => {
        return (
            <Button
                size='medium'
                style={{ marginTop: error ? '5px' : '25px', transition: 'color 0.3s' }}
                disabled={pickedGroup === "" || !pickedSystems?.length}
                data-testid='addSystemsToGroup'
                onClick={(e) => { handleAddSystemsToGroup() }}
            >
                Save
            </Button>
        );
    };

    const renderMobileNotifications = (): JSX.Element => {
        const error = addSystemsToGroupFailed || emptySystemError;
        const headerStyle = utils.getHeaderStyle(error);

        if (!mobileView) return null;
        if (error || addSystemsToGroupSucceeded) {
            const className = error ? 'notification-open-create-account-fail' : 'notification-open-create-account-success';
            return (
                <h5 className={className} style={headerStyle}>
                    {addSystemsToGroupFailed
                        ? 'Could not save system group.' 
                        : 'System group saved successfully.'}
                </h5>
            );
        }
        return <div style={utils.emptyHeaderStyle}></div>;
    };

    if (systems.length < 1) {
        return (
            <Card>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <SystemIcon />
                    </CardIcon>
                    <h4 data-testid='addSystemsToGroupHeader' className={classes.cardIconTitle}>
                        Modify System Group
                    </h4>
                </CardHeader>
                <CardBody>Please add a system first.</CardBody>
            </Card>
        );
    }

    return (
        <Card className='addSystemsToGroupForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <SystemIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Add/Remove Systems</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()}>
                    <div style={{ width: '100%' }}>
                        <Autocomplete
                            options={systemGroupOptions}
                            getOptionLabel={(group) => group}
                            id='group-name'
                            value={pickedGroup}
                            onChange={(event, newValue) => handlePickGroup(event, newValue)}
                            renderInput={(systemGroups) => <TextField {...systemGroups} label='System Groups' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                    </div>
                </FormControl>
                <div className="card" style={{marginTop: '10px'}} hidden={!pickedGroup}>
                    <PickList dataKey="ID" source={allSystems} target={pickedSystems} onChange={onChange} itemTemplate={itemTemplate} filter filterBy="name" breakpoint="1280px"
                        sourceHeader="Available" targetHeader="Selected" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
                        sourceFilterPlaceholder="Search by name" targetFilterPlaceholder="Search by name" autoOptionFocus={false} 
                        showSourceControls={false} showTargetControls={false} focusOnHover={false} onFocus={e => e.preventDefault()}/>
                </div>
                {renderMobileNotifications()}
                {pinButton()}
            </CardBody>
            {!mobileView ? (
                <>
                    <Snackbar
                        close
                        closeNotification={() => closeAddSystemsToGroupNotification()}
                        color={addSystemsToGroupFailed ? 'danger' : 'success'}
                        message={addSystemsToGroupFailed ? 'Could not save system group.' : 'System group saved successfully.'}
                        open={addSystemsToGroupFailed || addSystemsToGroupSucceeded}
                        place='tc'
                    />
                </>
            ) : null}
        </Card>
    );
};

const mapStateToProps = (state) => ({
    systemGroups: state.installer.systemGroups,
    systemsForGroup: state.dashboard.systemsForGroup,
    addSystemsToGroupFailed: state.dashboard.addSystemsToGroupFailed,
    addSystemsToGroupSucceeded: state.dashboard.addSystemsToGroupSucceeded,
    emptySystem: state.dashboard.emptySystem,
    mobileView: state.dashboard.mobileView,
});
const actions = {
    getSystemGroups,
    addSystemsToGroup,
    getSystemsForGroup
};

const AddSystemsToGroupWithStyles = regularFormsStyle(AddSystemsToGroup);
export default connect(mapStateToProps, actions)(AddSystemsToGroupWithStyles);
